import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./AddAccountForm";
import {LIST_TERRITORIES} from "../../queries/shipping";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelAddAccount} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "name");
  errors = validatePresence(errors, values, "jurisdictionId");

  return errors.toJS();
}


class AddAccountFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("customerId", this.props.customerId);
    return this.props.addAccount(updatedValues.toJS())
      .then((response) => {
        if (response.data.addAccount.errors.length <= 0) {
          this.props.cancelAddAccount();
        } else {
          let errors = createValidationErrors(response.data.addAccount.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAddAccount();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let territories = fromJS(data.territories);
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        territories={territories}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const ADD_ACCOUNT = gql`
  mutation addAccount($data: NewAccountInput!) {
    addAccount(input: $data) {
      errors { key message }
    }
  }
`;

const withAddressQuery = compose(
  graphql(LIST_TERRITORIES, {
    options: (props) => ({
      fetchPolicy: "network-only"
    })
  }),
  graphql(ADD_ACCOUNT, {
    props: ({ mutate }) => ({
      addAccount: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const AddAccountFormContainerWithData = withAddressQuery(AddAccountFormContainer);

export default connect(null, {cancelAddAccount})(AddAccountFormContainerWithData);